import '@fortawesome/fontawesome-free/css/fontawesome.css';
import '@fortawesome/fontawesome-free/css/solid.css';
import { createGlobalStyle } from 'styled-components';

import { theme } from './theme';

/**
 * Global styles for the application.
 *
 * These styles are applied to the entire application and should be used sparingly.
 * Prefer component-level styles using styled-components or the theme system.
 */
export const GlobalStyles = createGlobalStyle`
    * {
        box-sizing: border-box;
        margin: 0;
        padding: 0;
        border: 0;
    }

    *:before,
    *:after {
        box-sizing: border-box;
    }

    html {
        font-size: 10px;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    }

    body {
        font-family: 'Inter', sans-serif;
        font-size: 14px;
        line-height: 1.5;
        color: ${theme.colors.foreground.default};
        background-color: ${theme.colors.background.default};
        padding-top: 0;
        height: 100vh;
    }

    input,
    button,
    select,
    textarea {
        font-family: inherit;
        font-size: inherit;
        line-height: inherit;
    }

    a {
        color: ${theme.colors.foreground.default};
        text-decoration: none;

        &:hover,
        &:focus {
            text-decoration: none;
        }
    }

    figure {
        margin: 0;
    }

    img {
        vertical-align: middle;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
        margin-top: 0;
    }

    button {
        background: transparent;
        cursor: pointer;
        outline: none;

        &:disabled {
            cursor: default;
        }
    }

    table {
        border-collapse: collapse;
        border-spacing: 0;
    }

    /* Google Places Autocomplete container */
    .pac-container {
        z-index: ${theme.zIndex.interactive} !important;
    }

    /* Modal backdrop - hide when empty */
    .backdrop:empty {
        display: none;
    }
`;
